import React from "react";
import styled from "styled-components";
import DockerCard from "./DockerCard";

const ControlDockHeader = styled.header`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;

  h2 {
    font-size: 20px;
    font-weight: 600;
  }

  p {
    font-size: 14px;
    font-weight: 400;
    color: #cecece;
  }
`;

const ControlDockContent = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
`;

export default function TileViewerTab({ taskList }) {
  return (
    <>
      <ControlDockHeader>
        <h2>프로젝트</h2>
        <p>관리중인 프로젝트를 확인할 수 있습니다.</p>
      </ControlDockHeader>
      <ControlDockContent>
        {taskList.map((task) => (
          <DockerCard key={task.id} task={task} />
        ))}
      </ControlDockContent>
    </>
  );
}
